import { z } from "zod";
import type { RelayCaptureView } from "@frontier/content/relay";
import { factionIdSchema } from "./auth-contracts.js";

export const relayCaptureViewSchema = z.strictObject({
  factionId: factionIdSchema.nullable(),
  contested: z.boolean(),
  radius: z.number().finite().positive().max(600),
}) satisfies z.ZodType<RelayCaptureView>;
